export const FoldersIds = {
  Guias: "00000000-0000-0000-0000-000000000000",
  Relatorios: "00000000-0000-0000-0000-000000000001",
  Documentos: "00000000-0000-0000-0000-000000000002",
  Outros: "00000000-0000-0000-0000-000000000003",
  CND: "00000000-0000-0000-0000-000000000004",
};
